import angular from 'angular';

module.exports = angular.module('common.services.flipDates', [
])
.factory('FlipDates', function($http) {
  return {
    fetchDates(flipId) {
      return $http.get(`/api/v1/flips/${flipId}/dates`).then((resp) => {
        return resp.data;
      });
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/flip-dates.js
 **/